import BaseSchema from "./base";

class SampleFlaskPrep extends BaseSchema {
  static primaryKey = "uuid";
  static tableName = "sampleFlaskPreps";
  static fields = [
    "uuid",
    "createdAt",
    "updatedAt",
    "AUTRE_SUPPORT",
    "BARBOTAGE",
    "BLANC_BARBOTAGE",
    "BLANC_FILTRAGE",
    "BLANC_RINCAGE",
    "FILTRE",
    "RENDEMENT",
    "RINCAGE",
    "fullParametersNames",
    "phaseOrder",
    "sample",
    "sampleParametersName",
    "installation",
    "phase",
  ];

  static dateFields = ["createdAt", "updatedAt"];
  static relatedFields = {
    sampleObject: {
      field: "sample",
      tableName: "samples",
    },
    phaseObject: {
      field: "phase",
      tableName: "phases",
    },
    installationObject: {
      field: "installation",
      tableName: "installations",
    },
  };
}

export default SampleFlaskPrep;
